export default __webpack_public_path__ + "static/thumb-landscape-9a78805835b4d1db9157f0aa1626fdaa.jpg";